import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDeliverySubcon extends BaseModelAPI {
	static entity = 'suratjalandeliverysubcon';
	static entityName = 'suratjalandeliverysubcon';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.suratJalanNumber = '';
			this.deliveryInstructionSubconId = '';
			this.deliveryInstructionSubcon = {};
			this.deliveryDate = '';
			this.customerId = '';
			this.customer = {};
			this.destinationId = '';
			this.destination = {};
			this.remarks = '';
			this.driverName = '';
			this.vehicleNumber = '';
			this.suratJalanDeliverySubconDetail = []
			this.isAlreadyDeliver = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}